/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateSocialUploadCompositionsDetailMutationRequest, CreateSocialUploadCompositionsDetailMutationResponse, CreateSocialUploadCompositionsDetailPathParams } from "../models/CreateSocialUploadCompositionsDetail";

export function getCreateSocialUploadCompositionsDetailUrl(id: CreateSocialUploadCompositionsDetailPathParams["id"]) {
  const res = { method: 'POST', url: `/compositions/${id}/social-uploads` as const }
  return res
}

/**
 * @summary Start social upload for a video-editor edit (composition context)
 * {@link /compositions/:id/social-uploads}
 */
export async function createSocialUploadCompositionsDetail(id: CreateSocialUploadCompositionsDetailPathParams["id"], data: CreateSocialUploadCompositionsDetailMutationRequest, config: Partial<RequestConfig<CreateSocialUploadCompositionsDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, CreateSocialUploadCompositionsDetailMutationRequest>({ method : "POST", url : getCreateSocialUploadCompositionsDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}